/** @jsxImportSource @emotion/react */
"use client";
import type { Interpolation } from "@emotion/react";

import type { HallowElement } from "../../../../types/hallowElement.types";
import type { HallowElementProps } from "../../../../types/hallowElementProps.types";
import type { WithAsChild } from "../../../../types/withAsChild.types";
import { determineElementFromAsChild } from "../../../../utils/determineElementFromAsChild";

const Element: HallowElement = "div";

const elementStyle: Interpolation = {
  display: "flex",
  flexDirection: "column",
  flexGrow: 1,
  justifyContent: "flex-end",
};

export type FullscreenModalFooterProps = WithAsChild<
  HallowElementProps<typeof Element>
>;

export const FullscreenModalFooter = ({
  asChild = false,
  children,
  ...props
}: FullscreenModalFooterProps) => {
  const DeterminedElement = determineElementFromAsChild({
    asChild,
    hallowElement: Element,
  });

  return (
    <DeterminedElement css={elementStyle} {...props}>
      {children}
    </DeterminedElement>
  );
};
